import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { ColumnDensity } from '@common/types';

const initialDensity: ColumnDensity = 'comfortable';

interface IDownloadsTableStore {
  density: ColumnDensity;
  setDensity: (density: ColumnDensity) => void;
  resetView: () => void;
}

export const useDownloadsTableStore = create<IDownloadsTableStore>()(
  persist(
    set => ({
      density: initialDensity,
      setDensity: density => set({ density }),
      resetView: () => set({ density: initialDensity }),
    }),
    {
      name: 'downloads-table-store',
    },
  ),
);
